function calcLength(axis) {
  return axis.max - axis.min;
}
export {
  calcLength
};
